// react
import { ReactNode } from 'react';

// material ui
import { Box, Stack, Typography } from '@mui/material';

interface FaqQuestionSectionWrapperProps {
  id: string;
  title: string;
  children: ReactNode;
  toggleSection: (id: string) => void;
  expanded: boolean;
}

const FaqQuestionSectionWrapper = ({
  id: _id,
  title,
  children,
  toggleSection: _toggleSection,
  expanded: _expanded,
}: FaqQuestionSectionWrapperProps) => {
  void _id;
  void _toggleSection;
  void _expanded;

  return (
    <Box sx={{ width: '100%', my: 1, bgcolor: 'transparent' }}>
      <Typography variant="h6" sx={{ fontSize: '1rem', mb: 1 }}>
        {title}
      </Typography>
      <Stack>{children}</Stack>
    </Box>
  );
};

export default FaqQuestionSectionWrapper;
